// https://github.com/tc39/proposal-global
var $export = require('./_export');

$export($export.G, { global: require('./_global') });



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/es7.global.js
 ** module id = 538
 ** module chunks = 2
 **/